import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';

import type { HpgFormValues } from '../schemas';
import { HpgFormMuestraRow } from './HpgFormMuestraRow';
import { HpgPromedioBadge } from './HpgPromedioBadge';

interface HpgFormMuestrasTableProps {
  noPaper?: boolean;
}

export function HpgFormMuestrasTable({ noPaper = false }: HpgFormMuestrasTableProps): JSX.Element {
  const { control } = useFormContext<HpgFormValues>();
  const { fields, append, remove } = useFieldArray({ control, name: 'muestras' });
  const watchedMuestras = useWatch({ control, name: 'muestras' });

  const content = (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: noPaper ? 0.5 : 2 }}>
        <Box>
          <Typography variant="h6" component="span">
            Muestras
          </Typography>
          <Typography variant="body2" color="text.secondary" component="span" sx={{ ml: 1 }}>
            {fields.length} de 25
          </Typography>
        </Box>
        <HpgPromedioBadge muestras={watchedMuestras ?? []} />
      </Box>

      <Table size="small" sx={{ '& .MuiTableCell-root': { py: 0.2 } }}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: 50 }}>N°</TableCell>
            <TableCell sx={{ width: 120 }}>Valor</TableCell>
            <TableCell sx={{ width: 160 }}>Identificación</TableCell>
            <TableCell>Observación</TableCell>
            <TableCell sx={{ width: 50 }} />
          </TableRow>
        </TableHead>
        <TableBody>
          {fields.map((f, i) => (
            <HpgFormMuestraRow
              key={f.id}
              index={i}
              onRemove={() => remove(i)}
              canRemove={fields.length > 1}
            />
          ))}
        </TableBody>
      </Table>

      <Tooltip title={fields.length >= 25 ? 'Máximo 25 muestras alcanzado.' : ''}>
        <span>
          <Button
            variant="outlined"
            fullWidth
            disabled={fields.length >= 25}
            onClick={() => {
              const toAdd = Math.min(5, 25 - fields.length);
              if (toAdd > 0) {
                append(
                  Array.from({ length: toAdd }, () => ({
                    identificacion: null,
                    valor: null,
                    observacion: null,
                  })),
                );
              }
            }}
            sx={{ mt: noPaper ? 1 : 2 }}
          >
            + Agregar 5 muestras
          </Button>
        </span>
      </Tooltip>
    </>
  );

  if (noPaper) return content;

  return (
    <Paper variant="outlined" sx={{ p: 3, mb: 3 }}>
      {content}
    </Paper>
  );
}
